const MIN_LENGTH = 2;
const MAX_ZIP_CODE_LENGTH = 12;
const MAX_TAG_NAME_LENGTH = 16;
const MAX_FIRST_NAME_LENGTH = 30;
const MAX_LAST_NAME_LENGTH = 30;
const MAX_CONTACT_NAME_LENGTH = 100;
const MAX_SENDER_NAME_LENGTH = 50;
const MIN_EMAIL_LENGTH = 5;
const MAX_EMAIL_LENGTH = 50;
const MAX_FEATURE_NAME_LENGTH = 100;
const MAX_COMPANY_NAME_LENGTH = 50;
const MAX_ADDRESS_LENGTH = 100;
const MAX_SEARCH_LENGTH = 100;
const MAX_SUBJECT_LENGTH = 100;
const MAX_DOMAIN_LENGTH = 100;
const MAX_PO_LENGTH = 100;
const MAX_COST_CENTER_LENGTH = 100;
const MAX_ADDITIONAL_THOUGHTS_LENGTH = 500;
const MY_COLLECTIONS_TABLE_LIMIT = 10;
const MAX_CITY_NAME_LENGTH = 50;

export {
  MAX_ADDITIONAL_THOUGHTS_LENGTH,
  MAX_ADDRESS_LENGTH,
  MAX_CITY_NAME_LENGTH,
  MAX_COMPANY_NAME_LENGTH,
  MAX_CONTACT_NAME_LENGTH,
  MAX_COST_CENTER_LENGTH,
  MAX_DOMAIN_LENGTH,
  MAX_EMAIL_LENGTH,
  MAX_FEATURE_NAME_LENGTH,
  MAX_FIRST_NAME_LENGTH,
  MAX_LAST_NAME_LENGTH,
  MAX_PO_LENGTH,
  MAX_SEARCH_LENGTH,
  MAX_SENDER_NAME_LENGTH,
  MAX_SUBJECT_LENGTH,
  MAX_TAG_NAME_LENGTH,
  MAX_ZIP_CODE_LENGTH,
  MIN_EMAIL_LENGTH,
  MIN_LENGTH,
  MY_COLLECTIONS_TABLE_LIMIT
};
